import { createIsomorphicFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

export const getRequestOnServer = createIsomorphicFn()
  .server(() => getRequest())
  .client(() => undefined);
